"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "girderClient", {
  enumerable: true,
  get: function get() {
    return _girderClient.default;
  }
});
exports.auth = void 0;

var _ducks = require("./ducks");

var _sagas = require("./sagas");

var _girderClient = _interopRequireDefault(require("@openchemistry/girder-client"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var auth = {
  actions: _ducks.authActions,
  selectors: _ducks.authSelectors,
  sagas: _sagas.authSagas,
  reducer: _ducks.authReducer
};
exports.auth = auth;